/*
 * Copyright (c) 2025. Sergey S. Chernov - All Rights Reserved
 *
 *  You may use, distribute and modify this code under the
 * terms of the private license, which you must obtain from the author
 *
 * To obtain the license, contact the author: https://t.me/real_sergeych or email to
 * real dot sergeych at gmail.
 */

package net.sergeych.crypto2

import com.ionspin.kotlin.crypto.util.encodeToUByteArray
import net.sergeych.bipack.BipackEncoder
import net.sergeych.crypto2.SymmetricKey.WithNonce

/**
 * Some key able to encrypt data with optional random fill that conceals message size
 * when needed.
 *
 * It is not serializable by design.
 * Custom implementations are, see [SymmetricKey] for example.
 */
interface EncryptingKey : NonceBased, KeyInstance {
    /**
     * Authenticated encrypting with optional random fill to protect from message size analysis.
     * Note that [randomFill] if present should be positive.
     */
    fun encrypt(plainData: UByteArray,randomFill: IntRange?=null): UByteArray {
        val nonce = randomNonce()
        return BipackEncoder.encode(WithNonce(
            encryptWithNonce(plainData,nonce,randomFill),
            nonce)
        ).toUByteArray()
    }

    fun encrypt(plainText: String,randomFill: IntRange? = null): UByteArray =
        encrypt(plainText.encodeToUByteArray(),randomFill)

    fun encryptWithNonce(plainData: UByteArray, nonce: UByteArray, randomFill: IntRange? = null): UByteArray
}

inline fun <reified T>EncryptingKey.encryptObject(value: T,randomFill: IntRange? = null): UByteArray =
    encrypt(BipackEncoder.encode(value).toUByteArray(),randomFill)
